import { createFileRoute } from "@tanstack/react-router";

import { AlphaPreviewPage } from "@/features/request/alpha";
import { requireAlphaFeatureFlag } from "@/lib/posthog-flags";

export const Route = createFileRoute(
  "/_auth/_app-shell/requests/$requestId/alpha_/designs/$designId/",
)({
  beforeLoad: requireAlphaFeatureFlag,
  component: AlphaPreviewPage,
  params: {
    parse: (rawParams) => ({
      designId: String(rawParams["designId"]),
      requestId: Number(rawParams["requestId"]),
    }),
  },
});
